import {
  Home,
  Building2,
  Wrench,
  Siren,
  Hammer,
  CloudLightning,
  FileCheck2,
  ShieldCheck,
} from "lucide-react";

export const CONTACT = {
  name: "Schuyler Corder",
  brand: "Blessed Roofing",
  company: "Pro West Roofing",
  phone: "(480) 960-4170",
  phoneRaw: "+14809604170",
  email: "schuyler.corder@prowest.com",
  city: "Phoenix, Arizona",
  hours: "Mon–Sun, 5:00 AM – 7:00 PM",
  emergency: "24/7 Emergency Service",
};

export const STATS = [
  { value: "1,200+", label: "Roofs Completed" },
  { value: "18", label: "Years of Experience" },
  { value: "4.9★", label: "Average Customer Rating" },
  { value: "100%", label: "Licensed & Insured" },
];

export const SERVICES = [
  {
    id: "residential",
    icon: Home,
    title: "Residential Roofing",
    blurb:
      "Tile, shingle, and flat roof systems engineered for Arizona heat — built to protect your home and your family for decades.",
  },
  {
    id: "commercial",
    icon: Building2,
    title: "Commercial Roofing",
    blurb:
      "TPO, foam, and coating solutions for businesses, HOAs, and property managers. Minimal disruption, maximum durability.",
  },
  {
    id: "repair",
    icon: Wrench,
    title: "Roof Repair",
    blurb:
      "Leaks, cracked tiles, worn flashing, and damaged underlayment fixed fast — before small problems become expensive ones.",
  },
  {
    id: "emergency",
    icon: Siren,
    title: "24/7 Emergency Repair",
    blurb:
      "Storm hit at 2 AM? Schuyler answers. Rapid-response tarping and emergency repairs available around the clock, every day.",
  },
  {
    id: "replacement",
    icon: Hammer,
    title: "Replacement & Installation",
    blurb:
      "Complete tear-offs and new-roof installs using premium materials and manufacturer-backed warranties you can trust.",
  },
  {
    id: "storm",
    icon: CloudLightning,
    title: "Storm & Hail Damage",
    blurb:
      "Monsoon, hail, and wind damage assessed and restored. Free, no-pressure inspections to catch hidden damage early.",
  },
  {
    id: "insurance",
    icon: FileCheck2,
    title: "Insurance Claims Help",
    blurb:
      "Schuyler works directly with your insurance carrier — documenting damage and guiding your claim from start to finish.",
  },
  {
    id: "inspection",
    icon: ShieldCheck,
    title: "Inspections & Maintenance",
    blurb:
      "Preventative tune-ups and detailed inspections that extend roof life and give you total peace of mind year-round.",
  },
];

export const WHY = [
  {
    title: "Backed By Pro West",
    text: "The crews, warranties, and resources of a established Arizona roofing company — with the personal accountability of one dedicated name.",
  },
  {
    title: "One Point of Contact",
    text: "From the first inspection to the final nail, you deal with Schuyler directly. No call centers, no runaround, no surprises.",
  },
  {
    title: "Straight Answers",
    text: "Honest assessments and transparent pricing. If your roof doesn't need replacing, Schuyler will tell you — and fix what does.",
  },
  {
    title: "Built For Arizona",
    text: "Specialized in desert sun, monsoon storms, and Valley heat. Materials and methods chosen specifically for our climate.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Marcus & Diane Whitfield",
    location: "Scottsdale, AZ",
    quote:
      "Schuyler completely changed how we think about contractors. He was on our roof the same afternoon we called, walked us through every photo of the damage, and never once tried to upsell us. Professional, friendly, and genuinely honest — our new roof looks incredible.",
  },
  {
    name: "Angela Ramirez",
    location: "Gilbert, AZ",
    quote:
      "After a monsoon tore off part of our roof, I was panicking. Schuyler answered at 11 PM, had a tarp on it that night, and handled the entire insurance claim for me. He's the most knowledgeable and patient person I've ever worked with. I've already referred three neighbors.",
  },
  {
    name: "Tom Becker",
    location: "Mesa, AZ",
    quote:
      "I got three quotes. Schuyler was the only one who actually got on the roof, explained what he found, and put it all in writing. The crew was clean, fast, and respectful. He checked in personally afterward to make sure I was happy. That's rare these days.",
  },
  {
    name: "Priya Nair",
    location: "Chandler, AZ",
    quote:
      "From start to finish Schuyler made a stressful situation easy. He's friendly, he explains things in plain English, and he clearly knows roofing inside and out. Our commercial property has never been in better hands. Could not recommend him more highly.",
  },
  {
    name: "Greg Sullivan",
    location: "Tempe, AZ",
    quote:
      "Honest, dependable, and incredibly knowledgeable. Schuyler caught hail damage two other inspectors missed and saved us thousands through our insurance. He treated our home like it was his own. A true professional.",
  },
  {
    name: "The Hendersons",
    location: "Peoria, AZ",
    quote:
      "We can't say enough good things about Schuyler. He was punctual, kind to our kids, and walked my elderly mother through every step. The new tile roof is beautiful and the price was exactly what he quoted. This is how every contractor should operate.",
  },
];

export const SERVICE_AREAS = [
  "Phoenix",
  "Scottsdale",
  "Mesa",
  "Tempe",
  "Chandler",
  "Gilbert",
  "Glendale",
  "Peoria",
  "Surprise",
  "Goodyear",
  "Avondale",
  "Queen Creek",
  "Buckeye",
  "Paradise Valley",
  "Cave Creek",
  "Fountain Hills",
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1602193289141-9605ad75d0a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  about:
    "https://images.unsplash.com/photo-1676972582823-dfd86a3f6c18?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  area: "https://images.unsplash.com/photo-1729041534038-fdc1f9cf3d3a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};
